// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-radio-button {
   margin: 5px;
}
.mat-form-field {
   width: 250px;
}
.custom {
   margin: 5px;
}
.live-search {
   background-color: #fff;
   box-sizing: border-box;
   box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);
   margin-top: 5px;
   position: absolute;
   width: 345px;
   z-index: 99;
   overflow: auto;
   max-height: 250px;
}

.live-search ul {
   list-style: none;
   margin: 0;
   padding: 0;
}
.live-search a {
   cursor: pointer;
   padding: 10px;
}
.live-search a:hover {
   background-color: #f4f5f7;
   text-decoration: none;
}
.live-search img {
   margin-right: 10px;
   object-fit: cover;
   min-width: 32px;
   width: 32px;
   height: 32px;
}
.live-search .name, .live-search .desc {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.live-search .desc {
   color: #999;
   font-size: 12px;
}
.live-search .not-found {
   padding: 10px 20px;
}

.doclist {
   list-style: none;
   margin: 9px 0 0;
   padding: 0;
   margin-bottom: 10px;
   max-height: 200px;
   max-width: 500px;
}
.doclist li {
   align-items: center;
   border-top: 1px solid transparent;
   border-bottom: 1px solid #eaeaea;
   margin-top: -1px;
}
.doclist li.selected {
   background-color: rgba(0,178,201,0.05);
   border-color: rgba(0,150,178,0.2);
}
.file-avatar-icon img {
   display: block;
   width: 32px;
   height: 32px;
   object-fit: contain;
   border-radius: 50%;
}
.file-avatar-icon img.cover {
   object-fit: cover;
}
.file-avatar img {
   display: block;
   margin: 10px;
   width: 32px;
   height: 32px;
   object-fit: contain;
   border-radius: 50%;
}
.file-avatar img.cover {
   object-fit: cover;
}
.file-filename {
   padding: 6px 0;
   max-width: 50%;
}
.file-filename a {
   cursor: pointer;
}
.file-username {
   display: inline-flex;
   /*max-width: 100%;*/
   width: 250px;
}
.file-username a {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.file-delete {
   display: block;
   /*margin-left: 5px;*/
   cursor: pointer;
}
.divider {
   border-bottom: 1px solid gainsboro;
}
.radio-group {
   margin: 15px 0px;
}
.mat-select {
   width: 120px;
   margin-left: 15px;
}
.main {
   overflow: auto;
}
.mat-button {
   background-color: #fff;
   /*border: 1px solid #ccc;*/
   border-radius: 3px;
   cursor: pointer;
   outline: none;
   position: relative;
   margin-left: 10px;
   min-width: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/corporate-permission/permission.component.css"],"names":[],"mappings":"AAAA;GACG,WAAW;AACd;AACA;GACG,YAAY;AACf;AACA;GACG,WAAW;AACd;AACA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,2CAA2C;GAC3C,eAAe;GACf,kBAAkB;GAClB,YAAY;GACZ,WAAW;GACX,cAAc;GACd,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;GACf,aAAa;AAChB;AACA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;AACA;GACG,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;GACf,WAAW;GACX,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,UAAU;GACV,mBAAmB;GACnB,iBAAiB;GACjB,gBAAgB;AACnB;AACA;GACG,mBAAmB;GACnB,iCAAiC;GACjC,gCAAgC;GAChC,gBAAgB;AACnB;AACA;GACG,sCAAsC;GACtC,iCAAiC;AACpC;AACA;GACG,cAAc;GACd,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB,kBAAkB;AACrB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,YAAY;GACZ,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB,kBAAkB;AACrB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,cAAc;AACjB;AACA;GACG,eAAe;AAClB;AACA;GACG,oBAAoB;GACpB,mBAAmB;GACnB,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,cAAc;GACd,oBAAoB;GACpB,eAAe;AAClB;AACA;GACG,kCAAkC;AACrC;AACA;GACG,gBAAgB;AACnB;AACA;GACG,YAAY;GACZ,iBAAiB;AACpB;AACA;GACG,cAAc;AACjB;AACA;GACG,sBAAsB;GACtB,0BAA0B;GAC1B,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;AAClB","sourcesContent":[".mat-radio-button {\n   margin: 5px;\n}\n.mat-form-field {\n   width: 250px;\n}\n.custom {\n   margin: 5px;\n}\n.live-search {\n   background-color: #fff;\n   box-sizing: border-box;\n   box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);\n   margin-top: 5px;\n   position: absolute;\n   width: 345px;\n   z-index: 99;\n   overflow: auto;\n   max-height: 250px;\n}\n\n.live-search ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.live-search a {\n   cursor: pointer;\n   padding: 10px;\n}\n.live-search a:hover {\n   background-color: #f4f5f7;\n   text-decoration: none;\n}\n.live-search img {\n   margin-right: 10px;\n   object-fit: cover;\n   min-width: 32px;\n   width: 32px;\n   height: 32px;\n}\n.live-search .name, .live-search .desc {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.live-search .desc {\n   color: #999;\n   font-size: 12px;\n}\n.live-search .not-found {\n   padding: 10px 20px;\n}\n\n.doclist {\n   list-style: none;\n   margin: 9px 0 0;\n   padding: 0;\n   margin-bottom: 10px;\n   max-height: 200px;\n   max-width: 500px;\n}\n.doclist li {\n   align-items: center;\n   border-top: 1px solid transparent;\n   border-bottom: 1px solid #eaeaea;\n   margin-top: -1px;\n}\n.doclist li.selected {\n   background-color: rgba(0,178,201,0.05);\n   border-color: rgba(0,150,178,0.2);\n}\n.file-avatar-icon img {\n   display: block;\n   width: 32px;\n   height: 32px;\n   object-fit: contain;\n   border-radius: 50%;\n}\n.file-avatar-icon img.cover {\n   object-fit: cover;\n}\n.file-avatar img {\n   display: block;\n   margin: 10px;\n   width: 32px;\n   height: 32px;\n   object-fit: contain;\n   border-radius: 50%;\n}\n.file-avatar img.cover {\n   object-fit: cover;\n}\n.file-filename {\n   padding: 6px 0;\n   max-width: 50%;\n}\n.file-filename a {\n   cursor: pointer;\n}\n.file-username {\n   display: inline-flex;\n   /*max-width: 100%;*/\n   width: 250px;\n}\n.file-username a {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.file-delete {\n   display: block;\n   /*margin-left: 5px;*/\n   cursor: pointer;\n}\n.divider {\n   border-bottom: 1px solid gainsboro;\n}\n.radio-group {\n   margin: 15px 0px;\n}\n.mat-select {\n   width: 120px;\n   margin-left: 15px;\n}\n.main {\n   overflow: auto;\n}\n.mat-button {\n   background-color: #fff;\n   /*border: 1px solid #ccc;*/\n   border-radius: 3px;\n   cursor: pointer;\n   outline: none;\n   position: relative;\n   margin-left: 10px;\n   min-width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
